import { Component, OnInit, DebugElement } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminService } from 'app/admin/admin.service';
import { resolveDefinition } from '@angular/core/src/view/util';
import { Router } from '@angular/router';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { NofeshOvedSingleReservation } from 'app/admin/interface/nofesh-oved-single-reservation';
import { ngContentDef } from '@angular/core/src/view';
import { IOvdimNofeshSingleReservation } from 'app/admin/interface/ovdim-nofesh-single-reservation';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';

@Component({
  selector: 'app-singles-unite',
  templateUrl: './singles-unite.component.html',
  styleUrls: ['./singles-unite.component.css']
})
export class SinglesUniteComponent implements OnInit {

  is_oved_mazmin_searched:boolean=false; 
  is_single_for_oved_mazmin:boolean=false;
  ms_zehut_mazmin_valid:boolean=true;
 
  is_oved_mishtatef_searched:boolean=false; 
  is_single_for_oved_mishtatef:boolean=false;
  ms_zehut_mishtatef_valid:boolean=true;
 
  isMazminAndMishtatefAreEqual_general:boolean = false;
  isMazminAndMishtatefAreEqual_mazmin:boolean = false;
  isMazminAndMishtatefAreEqual_mishtatef:boolean = false;

  isOvedMazminFound : boolean = false;
  isOvedMishtatefFound : boolean = false;

  get ms_zehut_mazmin_error() { return this.singlesUniteForm.get('ms_zehut_mazmin'); }
  get ms_zehut_mishtatef_error() { return this.singlesUniteForm.get('ms_zehut_mishtatef'); }

  singlesUniteForm = this.fb.group({
    //main mazmin
    ms_zehut_mazmin:['',Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    tr_leida:[''],
    shem_prati:[''],
    shem_mishpacha:[''],
    ms_zehut:[''],
    phone:[''],
    nofesh_title:[''],
    nofesh_from:[''],
    nofesh_to:[''],
    is_hamtana_mazmin:[''],
    //mishtatef
    ms_zehut_mishtatef:['',Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    tr_leida_mishtatef:[''],
    shem_prati_mishtatef:[''],
    shem_mishpacha_mishtatef:[''],
    phone_mishtatef:[''],
    nofesh_title_mishtatef:[''],
    nofesh_from_mishtatef:[''],
    nofesh_to_mishtatef:[''],
    is_hamtana_mishtatef:['']
  })

  constructor(private fb:FormBuilder,
              private _adminService: AdminService,
              private router: Router,
              private confirmService: ConfirmService,
              private userMessage: UserMessagesService,
              private dialog: MatDialog) { }

  ngOnInit() {


  }

  validateOvedmsZehut(ms_zehut)
  {
    console.log(this.ms_zehut_mazmin_error.errors);
    let valid_zehut = this.validatemsZehut(ms_zehut);
    debugger;
    if (valid_zehut) {
        this.ms_zehut_mazmin_valid = true;
    }
    else {
        this.ms_zehut_mazmin_valid = false;
        this.singlesUniteForm.patchValue({ ms_zehut: "" });
        return;
    }
  }
  validatemsZehut(value) {

    if (value.length == 0)
        return false;
    console.log(value.length);


    var result = true;
    var first8 = null;
    var cifratBikoret = null;
    try {
        if (value.length == 10)
            first8 = value.substring(0, 9);
        else {
            if (value.length == 9)
                first8 = "0" + value.substring(0, 8);
            else
                first8 = "00" + value.substring(0, 8);
        }
        cifratBikoret = value.substring(value.length - 1);
        var checkDigits = 0 * 1;
        var temp = 0;
        var i = 0;

        for (i = 1; i <= 9; i++) {
            temp = first8.charAt(i - 1);
            checkDigits = temp * 1 + checkDigits * 1;
            if ((i % 2) == 1) {
                checkDigits = temp * 1 + checkDigits * 1;
                if (temp > 4)
                    checkDigits = checkDigits * 1 - 9;
            }
        }
        checkDigits = (10 - checkDigits % 10) % 10;
        result = (checkDigits * 1 == cifratBikoret * 1);
    }
    catch (e) { result = false; }
    if (value == "0")
        result = false;
    return result;
}
isOvedHasSingleNofeshAndMsZehutValid()
{
    //clear all fields when searching for new oved
    this.isMazminAndMishtatefAreEqual_general = false;
    this.singlesUniteForm.patchValue({ 
      tr_leida:[''],
      shem_prati:[''],
      shem_mishpacha:[''],
      phone:[''],
      nofesh_title:[''],
      nofesh_from:[''],
      nofesh_to:[''],
      is_hamtana_mazmin:[''],
    })

  let is_hamtana_mazmin :string;
  this.isMazminAndMishtatefEqual();
  if(this.isMazminAndMishtatefAreEqual_general)
  {
    this.isMazminAndMishtatefAreEqual_mazmin = true;
    this.singlesUniteForm.patchValue({ 
      ms_zehut_mazmin:[''],
      tr_leida:[''],
      shem_prati:[''],
      shem_mishpacha:[''],
      ms_zehut:[''],
      phone:[''],
      nofesh_title:[''],
      nofesh_from:[''],
      nofesh_to:[''],
      is_hamtana_mazmin:[''],
    })
    return;
  }

  this.validateOvedmsZehut(this.singlesUniteForm.value.ms_zehut_mazmin);
  if(this.ms_zehut_mazmin_valid)
  {
    this._adminService.GetOvedNofeshSingleReservation(this.singlesUniteForm.value.ms_zehut_mazmin).subscribe((res)=>{
      
      if(res.data && res.isSuccess)
      {
        this.isOvedMazminFound = true;
        sessionStorage.setItem("nofeshSingleMazmin", JSON.stringify(res.data));//mazmin

        if(res.data.is_hamtana)
        {
          is_hamtana_mazmin = 'כן'
        }
        else
        {
          is_hamtana_mazmin = 'לא'
        }

        this.is_oved_mazmin_searched = true;   
        this.is_single_for_oved_mazmin=true;
        this.singlesUniteForm.patchValue({ 
        tr_leida: res.data.tr_leida,
        shem_prati:res.data.shem_prati,
        shem_mishpacha:res.data.shem_mishpacha,
        ms_zehut:res.data.ms_zehut,
        phone:res.data.phone,
        nofesh_title:res.data.nofesh_title,
        nofesh_from:res.data.nofesh_from,
        nofesh_to:res.data.nofesh_to ,
        is_hamtana_mazmin: is_hamtana_mazmin
        });
        
        this.isMazminAndMishtatefAreEqual_mazmin = false;
      }
      else
      {
        this.is_oved_mazmin_searched = true;    
        this.is_single_for_oved_mazmin=false;
        this.singlesUniteForm.patchValue({ ms_zehut_mazmin:''});
      }
      },error=>{console.log(error);
    })
  }
}
isOvedHasSingleNofeshAndMsZehutValidMishtatef()
{
  
    //clear all fields when searching for new oved
    this.isMazminAndMishtatefAreEqual_general = false;
    this.singlesUniteForm.patchValue({ 
      shem_prati_mishtatef:[''],
      shem_mishpacha_mishtatef:[''],
      tr_leida_mishtatef:[''],
      phone_mishtatef:[''],
      nofesh_title_mishtatef:[''],
      nofesh_from_mishtatef:[''],
      nofesh_to_mishtatef:[''],
      is_hamtana_mishtatef:['']
    })
  
  let is_hamtana_nilve :string;
  this.isMazminAndMishtatefEqual();
  if(this.isMazminAndMishtatefAreEqual_general)
  {
    this.isMazminAndMishtatefAreEqual_mishtatef = true;
    this.singlesUniteForm.patchValue({ 
      ms_zehut_mishtatef:[''],
      shem_prati_mishtatef:[''],
      shem_mishpacha_mishtatef:[''],
      tr_leida_mishtatef:[''],
      ms_zehut:[''],
      phone_mishtatef:[''],
      nofesh_title_mishtatef:[''],
      nofesh_from_mishtatef:[''],
      nofesh_to_mishtatef:[''],
      is_hamtana_mishtatef:['']
    })
    return;
  }
  this.validateOvedmsZehut(this.singlesUniteForm.value.ms_zehut_mishtatef);
  if(this.ms_zehut_mishtatef_valid)
  {
    this._adminService.GetOvedNofeshSingleReservation(this.singlesUniteForm.value.ms_zehut_mishtatef).subscribe((res)=>{

      if(res.data && res.isSuccess)
      {
        this.isOvedMishtatefFound = true;
        sessionStorage.setItem("nofeshSingleMishtatef", JSON.stringify(res.data));//mishtatef
        if(res.data.is_hamtana)
        {
          is_hamtana_nilve = 'כן'
        }
        else
        {
          is_hamtana_nilve = 'לא'
        }

        this.is_oved_mishtatef_searched = true;   
        this.is_single_for_oved_mishtatef=true;
        this.singlesUniteForm.patchValue({ 
          tr_leida_mishtatef:res.data.tr_leida,
          shem_prati_mishtatef:res.data.shem_prati,
          shem_mishpacha_mishtatef:res.data.shem_mishpacha,
          phone_mishtatef:res.data.phone,
          nofesh_title_mishtatef:res.data.nofesh_title,
          nofesh_from_mishtatef:res.data.nofesh_from,
          nofesh_to_mishtatef:res.data.nofesh_to,
          is_hamtana_mishtatef:is_hamtana_nilve
        });
        
        this.isMazminAndMishtatefAreEqual_mishtatef = false;
      }
      else
      {
        this.is_oved_mishtatef_searched = true;    
        this.is_single_for_oved_mishtatef=false;
        this.singlesUniteForm.patchValue({ ms_zehut_mishtatef:''});
      }
      },error=>{console.log(error);
    })
  }
}
onMsZehutSearchChange(value:string){
  this.is_oved_mazmin_searched = false;
  
}
onMsZehutMishtatefSearchChange(value:string){
  this.is_oved_mazmin_searched = false;
}
//validate that the mazmin and mishtatef/nilve are not equal!
isMazminAndMishtatefEqual()
{
  let ms_zehut_mazmin = this.singlesUniteForm.value.ms_zehut_mazmin;
  let ms_zehut_mishtatef = this.singlesUniteForm.value.ms_zehut_mishtatef;
  if(ms_zehut_mazmin==ms_zehut_mishtatef)
  {
    this.isMazminAndMishtatefAreEqual_general = true;
  }
  else
  {
    this.isMazminAndMishtatefAreEqual_general = false;
  }
}

uniteSinglesDialog()
{
  debugger;
  //TODO: check each oved is not null...!
  let nofeshsingleMazmin: NofeshOvedSingleReservation = JSON.parse(sessionStorage.getItem("nofeshSingleMazmin")) as NofeshOvedSingleReservation;
  let nofeshsingleMishtatef: NofeshOvedSingleReservation = JSON.parse(sessionStorage.getItem("nofeshSingleMishtatef")) as NofeshOvedSingleReservation;

  let nofeshOvdimSingles : IOvdimNofeshSingleReservation =  new IOvdimNofeshSingleReservation();
  nofeshOvdimSingles.mazmin = nofeshsingleMazmin;
  nofeshOvdimSingles.mishtatef = nofeshsingleMishtatef;

  if(nofeshsingleMazmin !=null && nofeshsingleMazmin!=undefined && nofeshsingleMishtatef!=null && nofeshsingleMishtatef!=undefined)
  {
    if(nofeshOvdimSingles.mazmin.id_nofesh!=nofeshOvdimSingles.mishtatef.id_nofesh)
    {
      
      this.userMessage.setErrorMessage("אין להזין עובדים עם נופש שונה!");
      this.singlesUniteForm.patchValue({ 
        ms_zehut_mishtatef:[''],
        shem_prati_mishtatef:[''],
        shem_mishpacha_mishtatef:[''],
        tr_leida_mishtatef:[''],
        ms_zehut:[''],
        phone_mishtatef:[''],
        nofesh_title_mishtatef:[''],
        nofesh_from_mishtatef:[''],
        nofesh_to_mishtatef:[''],
        is_hamtana_mishtatef:['']
      })
      this.singlesUniteForm.patchValue({ 
        ms_zehut_mazmin:[''],
        tr_leida:[''],
        shem_prati:[''],
        shem_mishpacha:[''],
        ms_zehut:[''],
        phone:[''],
        nofesh_title:[''],
        nofesh_from:[''],
        nofesh_to:[''],
        is_hamtana_mazmin:[''],
      })



    }
    else
    {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;

      dialogConfig.data = {title:"איחוד סינגלים - מאורגנים",text:"האם אתה בטוח שברצונך לאחד בין שני הסינגלים?"};
      let dialogRef = this.dialog.open(ConfirmDialogComponent,dialogConfig);

      let httpResponse : boolean = undefined;
      let confirmSubscription  = this.confirmService.confirm$.subscribe((confirm:boolean) => {
        if(confirm)
        {
          this._adminService.nofeshUniteSingles(nofeshOvdimSingles).subscribe(response => {
            httpResponse = response.isSuccess;
            confirmSubscription.unsubscribe();
            this.confirmService.closeDialog();
          })
        }
      });
      dialogRef.afterClosed().subscribe((result:boolean) => {
        if(httpResponse)
        {
          this.userMessage.setSuccessMessage("האיחוד בוצע בהצלחה");
        }
        else if(httpResponse == undefined)
        {
          //navigate to main page(close diaolog actually)
          this.router.navigateByUrl("admin/nofesh-admin/singles-unite");
        }
        else
        {
          this.userMessage.setErrorMessage("בעיה באיחוד סינגלים, אנא נסה שוב מאוחר");
        }
      })
    sessionStorage.removeItem("nofeshSingleMazmin");
    sessionStorage.removeItem("nofeshSingleMishtatef");

    }
      
  }
  else
  {
    //error message that one or more employees details are missing...!
    this.userMessage.setErrorMessage("חסרים פרטים של עובד אחד או יותר");
  }
  
}

}
